module.exports = __webpack_public_path__ + "img/mask1.ebc08a8f.jpeg";